import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Text, Icon, Flex, Button, Stack } from '@tonic-ui/react';
import { shallowEqual, useSelector } from 'react-redux';

import { getC1UserDetails } from '../../store';
import { downloadTextAsFile } from '../../utils/helpers';
import { CopyToClipBoard } from '../../components/copy-to-clipboard';
import { UserPoolProxyAPI } from '../../services';

interface IMfaResetCodeProps {
  onErrorCallback?: (err?: any) => void;
}

export const MfaResetCode = ({ onErrorCallback }: IMfaResetCodeProps): JSX.Element => {
  const { t } = useTranslation();
  const { data, error, isError } = UserPoolProxyAPI.useGetCognitoMfaResetCode();
  const resetCode = data?.code;

  useEffect(() => {
    if (isError && onErrorCallback) {
      onErrorCallback(error);
    }
  }, [isError]);

  const { username } = useSelector(
    (state) => ({
      username: getC1UserDetails(state, 'name'),
    }),
    shallowEqual
  );

  const handleOnDownload = () => {
    if (!resetCode) return;

    const formattedUsername = username.replace(/[\W\s]/gi, '_').toLowerCase();
    downloadTextAsFile(resetCode, `cloud_one_mfa_reset_code_${formattedUsername}`);
  };

  return (
    <Stack direction="column" spacing="4x">
      <Text size="sm">{t('enableMfaModal.resetCodeMessage')}</Text>
      <CopyToClipBoard value={resetCode} textareaRowsCount={1} />
      <Flex direction="row" justify="end" marginTop="2x">
        <Button
          disabled={!resetCode}
          onClick={handleOnDownload}
          data-id="download-mfa-reset-code-button"
        >
          <Icon icon="download" marginRight="1x" />
          {t('enableMfaModal.download')}
        </Button>
      </Flex>
    </Stack>
  );
};

MfaResetCode.displayName = 'MfaResetCode';

export default MfaResetCode;
